import React from 'react';
import styles from './HeaderPage.module.scss';
import uol_logo_header from '../../../../../assets/images/logo_uol_host.svg';


const UHCHeader: React.FC = () => {

    return (
        <header className={styles['background']}>
            <div className={`${styles['content']} container`}>
                <img src={uol_logo_header} className={styles['uol-logo']} alt="Logo da UOL host" /> 
                <div className={styles['seguro-logo']} role="img" aria-label="Logo de site seguro UOL" />
            </div>
        </header>
    );
};

export default UHCHeader;